<ng-autocomplete
  [data]="data"
  [initialValue]="selectedValue"
  (inputChanged)="searchClient($event)"
  [placeholder]="'Client ID'"
  [isLoading]="isLoading"
  [debounceTime]="700"
>
</ng-autocomplete>
